"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14271%3A942))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSRTrashCan = createSVGIcon(
  <path
    d="M2.75 5.5a.75.75 0 0 0 0 1.5V5.5M21.25 7a.75.75 0 0 0 0-1.5V7m-16.5-.75V5.5H4v.75zm14.531 0h.75V5.5h-.75zm0 15V22h.75v-.75zm-14.531 0H4V22h.75zm3.5-15a.75.75 0 0 0 1.5 0h-1.5M9 5.667h-.75zm5.25.583a.75.75 0 0 0 1.5 0h-1.5m-4 3.875a.75.75 0 0 0-1.5 0h1.5m-1.5 7.5a.75.75 0 0 0 1.5 0h-1.5m6.5-7.5a.75.75 0 0 0-1.5 0h1.5m-1.5 7.5a.75.75 0 0 0 1.5 0h-1.5M2.75 6.25V7h18.5V5.5H2.75zm2 0V7h14.531V5.5H4.75zm14.531 15h.75v-15h-1.5v15zm0 0v-.75H4.75V22h14.531zm-14.531 0h.75v-15H4v15zM9 6.25h.75v-.583h-1.5v.583zm0-.583h.75c0-.568.232-1.117.652-1.525l-.523-.538-.523-.537a3.63 3.63 0 0 0-1.106 2.6zm.879-2.063.523.538c.42-.409.995-.642 1.598-.642V2c-.988 0-1.94.381-2.644 1.067zM12 2.75v.75c.603 0 1.178.233 1.598.642l.523-.538.523-.537A3.8 3.8 0 0 0 12 2zm2.121.854-.523.538c.42.408.652.957.652 1.525h1.5c0-.98-.4-1.915-1.106-2.6zM15 5.667h-.75v.583h1.5v-.583zm-5.5 4.458h-.75v7.5h1.5v-7.5zm5 0h-.75v7.5h1.5v-7.5z"
    fill="currentColor"
  />,
  "BSRTrashCan",
  (strictLocalize) => ({
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    titleAccess: strictLocalize({
      id: "tv4IoW",
      defaultMessage: "Remove",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    viewBox: "0 0 24 24",
  })
);
